import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sparkles, Facebook, Twitter } from 'lucide-react';

// Social share component
const SocialShareLinks = () => {
  const { t, i18n } = useTranslation();
  const siteUrl = 'https://tantra-map.com';
  
  // Get share text based on current language
  const getShareText = () => {
    const texts = {
      es: 'Descubre Tantra Map - La mapa de los profesionales del tantra',
      en: 'Discover Tantra Map - The map of tantra professionals',
      it: 'Scopri Tantra Map - La mappa dei professionisti del tantra'
    };
    return texts[i18n.language] || texts.es;
  };
  
  const shareText = encodeURIComponent(getShareText());
  const shareUrl = encodeURIComponent(siteUrl);
  
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&quote=${shareText}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`;
  
  return (
    <div className="flex items-center gap-3">
      <span className="text-gray-400 text-sm">{t('footer.share')}:</span>
      <a 
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-full bg-gray-700/50 hover:bg-gray-600 transition-colors"
        aria-label="Share on Facebook"
      >
        <Facebook className="h-4 w-4 text-gray-300 hover:text-white" />
      </a>
      <a 
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="p-2 rounded-full bg-gray-700/50 hover:bg-gray-600 transition-colors"
        aria-label="Share on Twitter"
      >
        <Twitter className="h-4 w-4 text-gray-300 hover:text-white" />
      </a>
    </div>
  );
};

export function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-primary text-white py-12 mt-16" style={{ backgroundColor: '#2C3E50' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Sparkles className="h-6 w-6 text-gold" style={{ color: '#D4A574' }} />
              <span className="font-serif text-xl font-bold">Tantra Map</span>
            </div>
            <p className="text-gray-400 text-sm">
              {t('home.subtitle')}
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('nav.home')}</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <Link to="/sesiones" className="block hover:text-gold">{t('nav.services')}</Link>
              <Link to="/formacion-y-eventos" className="block hover:text-gold">{t('nav.courses')}</Link>
              <Link to="/profesionales" className="block hover:text-gold">{t('nav.teachers')}</Link>
              <Link to="/escuelas" className="block hover:text-gold">{t('nav.schools')}</Link>
              <Link to="/blog" className="block hover:text-gold">Blog</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer.legal')}</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <Link to="/privacy" className="block hover:text-gold">{t('footer.privacy')}</Link>
              <Link to="/legal" className="block hover:text-gold">{t('footer.legal')}</Link>
              <Link to="/cookies" className="block hover:text-gold">{t('footer.cookies')}</Link>
              <Link to="/terms" className="block hover:text-gold">{t('footer.terms')}</Link>
              <Link to="/professional-guidelines" className="block hover:text-gold">{t('footer.guidelines')}</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>info@tantra-map.com</p>
              <p>Islas Canarias, España</p>
            </div>
            {/* Social Share Links */}
            <div className="mt-4">
              <SocialShareLinks />
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2026 Tantra Map. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
}
